import langEN from '../../../locales/en-US.json'
import langVI from '../../../locales/vi-VN.json'
import { EN } from './config/languages'

// const publicUrl = 'https://locales.pancakeswap.finance'

export const LS_KEY = 'pancakeswap_language'

export const fetchLocale = async (locale: string) => {
  if (locale.includes('vi')) return langVI
  return langEN
}

export const getLanguageCodeFromLS = () => {
  try {
    const codeFromStorage = localStorage.getItem(LS_KEY)

    return codeFromStorage || EN.locale
  } catch {
    return EN.locale
  }
}
